export default "__VITE_ASSET__a862f123__"